import { AppState } from '../../../redux/reducers';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import * as MedicalProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';

interface IProps {
    SettlementId: number;
}

interface ConnectedProps {
    Settlement: Settlement | undefined;
    accessToken: string | undefined;
    /** Cambia cuando el servidor recalculó o cambió de estado: hay que releer el desglose. */
    refreshKey: string;
    /** Título del protocolo desde el store; el API sólo manda su número. */
    ProtocolTitleOf: (protocolId: number) => string | undefined;
    hasProtocols: boolean;
}

interface DispatchProps {
    GetAllMedicalProtocols: typeof MedicalProtocolStore.actionCreators.GetAllMedicalProtocols;
}

export type Props = IProps & ConnectedProps & DispatchProps;

// connect() compara por identidad: la función se rehace sólo cuando cambia la lista.
let lastProtocols: Protocol[] | undefined;
let lastLookup: ((protocolId: number) => string | undefined) | undefined;
export const getProtocolTitleLookup = (protocols: Protocol[] | undefined) => {
    if (protocols !== lastProtocols || !lastLookup) {
        lastProtocols = protocols;
        const byId = new Map<number, string>((protocols || []).map((protocol: Protocol) => [protocol.id, protocol.title]));
        lastLookup = (protocolId: number) => byId.get(protocolId);
    }
    return lastLookup;
};

export const mapStateToProps = (state: AppState, ownProps: IProps): ConnectedProps => {
    const settlement = state.Settlement?.list?.find((item: Settlement) => item.id === ownProps.SettlementId);
    const totalsKey = (settlement?.totals ?? []).map((total) => `${total.currencyCode}:${total.totalValue}`).join('|');
    const protocols = state.MedicalProtocols?.list;
    return {
        Settlement: settlement,
        accessToken: state.oidc?.user?.access_token,
        refreshKey: `${settlement?.status ?? ''}|${settlement?.isRecalculating ? 'r' : ''}|${settlement?.debts?.length ?? 0}|${totalsKey}`,
        ProtocolTitleOf: getProtocolTitleLookup(protocols),
        hasProtocols: (protocols?.length ?? 0) > 0,
    };
};

export const mapDispatchToProps = {
    GetAllMedicalProtocols: MedicalProtocolStore.actionCreators.GetAllMedicalProtocols,
};
